// Dynamic API base URL that works for both localhost and production (cPanel)
// This is kept in sync with the logic in `src/services/api.js`
export const BASE_API_URL_FOR_NODEJS = (() => {
  // If explicitly configured at build time, respect that
  if (process.env.REACT_APP_API_URL) {
    return `${process.env.REACT_APP_API_URL}/api`;
  }

  // Production API domain
  return 'https://api.avsbusiness.in/api';
})();


// ============================================================================
// AUTHENTICATION APIs
// ============================================================================
const AUTH_LOGIN = `${BASE_API_URL_FOR_NODEJS}/auth/login`;
const AUTH_REGISTER = `${BASE_API_URL_FOR_NODEJS}/auth/register`;
const AUTH_ME = `${BASE_API_URL_FOR_NODEJS}/auth/me`;
const AUTH_PROFILE = `${BASE_API_URL_FOR_NODEJS}/auth/profile`;
const AUTH_CHANGE_PASSWORD = `${BASE_API_URL_FOR_NODEJS}/auth/change-password`;
const AUTH_FORGOT_PASSWORD = `${BASE_API_URL_FOR_NODEJS}/auth/forgot-password`;
const AUTH_RESET_PASSWORD = `${BASE_API_URL_FOR_NODEJS}/auth/reset-password`;
const ADMIN_LOGIN = `${BASE_API_URL_FOR_NODEJS}/admin/login`;

// ============================================================================
// ADMIN APIs
// ============================================================================
const ADMIN_USERS = `${BASE_API_URL_FOR_NODEJS}/admin/users`;
const ADMIN_USERS_UPDATE_ROLE = (userId) => `${BASE_API_URL_FOR_NODEJS}/admin/users/${userId}/role`;
const ADMIN_USERS_DELETE = (userId) => `${BASE_API_URL_FOR_NODEJS}/admin/users/${userId}`;

// Admin User Management (Alternative naming conventions)
const UPDATE_ROLE_OF_ADMIN = `${BASE_API_URL_FOR_NODEJS}/update_role_of_admin`;
const UPDATE_NAME_OF_ADMIN = `${BASE_API_URL_FOR_NODEJS}/update_name_of_admin`;
const UPDATE_EMAIL_OF_ADMIN = `${BASE_API_URL_FOR_NODEJS}/update_email_of_admin`;
const DELETE_ADMIN_USER = `${BASE_API_URL_FOR_NODEJS}/delete_Admin_User`;
const UPDATE_ADMIN_USER_PASSWORD = `${BASE_API_URL_FOR_NODEJS}/update_Admin_User_Password`;
const UPDATE_ADMIN_USER = `${BASE_API_URL_FOR_NODEJS}/admin-users`;
const ADMIN_PRODUCTS = `${BASE_API_URL_FOR_NODEJS}/admin/products`;
const ADMIN_PRODUCTS_BY_ID = (id) => `${BASE_API_URL_FOR_NODEJS}/admin/products/${id}`;
const ADMIN_PRODUCTS_CATEGORIES = `${BASE_API_URL_FOR_NODEJS}/admin/products/categories`;
const ADMIN_ORDERS = `${BASE_API_URL_FOR_NODEJS}/admin/orders`;
const ADMIN_ANALYTICS = `${BASE_API_URL_FOR_NODEJS}/admin/analytics`;
const ADMIN_SALES_HISTORY = `${BASE_API_URL_FOR_NODEJS}/admin/sales/history`;

// ============================================================================
// ACCOUNTS APIs
// ============================================================================
const ACCOUNTS = `${BASE_API_URL_FOR_NODEJS}/accounts`;
const ACCOUNTS_PARENT = `${BASE_API_URL_FOR_NODEJS}/accounts?isParent=true`;
const ACCOUNTS_CHART = `${BASE_API_URL_FOR_NODEJS}/accounts/chart`;
const ACCOUNTS_BY_ID = (id) => `${BASE_API_URL_FOR_NODEJS}/accounts/${id}`;

// ============================================================================
// ACCOUNTS LEDGER APIs
// ============================================================================
const ACCOUNTS_LEDGER = `${BASE_API_URL_FOR_NODEJS}/accounts-ledger`;
const ACCOUNTS_LEDGER_BY_ID = (id) => `${BASE_API_URL_FOR_NODEJS}/accounts-ledger/${id}`;

// ============================================================================
// BILLING APIs
// ============================================================================
const BILLING = `${BASE_API_URL_FOR_NODEJS}/billing`;
const BILLING_BY_ID = (id) => `${BASE_API_URL_FOR_NODEJS}/billing/${id}`;
const BILLING_FROM_QUOTATION = `${BASE_API_URL_FOR_NODEJS}/billing/from-quotation`;
const BILLING_CLIENT_LEDGER = `${BASE_API_URL_FOR_NODEJS}/billing/clients/ledger`;

// ============================================================================
// COMPANIES APIs
// ============================================================================
const COMPANIES = `${BASE_API_URL_FOR_NODEJS}/companies`;
const COMPANIES_BY_ID = (id) => `${BASE_API_URL_FOR_NODEJS}/companies/${id}`;

// ============================================================================
// CUSTOMERS APIs
// ============================================================================
const CUSTOMERS = `${BASE_API_URL_FOR_NODEJS}/customers`;
const CUSTOMERS_BY_ID = (id) => `${BASE_API_URL_FOR_NODEJS}/customers/${id}`;

// ============================================================================
// INVENTORY APIs
// ============================================================================
const INVENTORY = `${BASE_API_URL_FOR_NODEJS}/inventory`;
const INVENTORY_BY_ID = (id) => `${BASE_API_URL_FOR_NODEJS}/inventory/${id}`;

// ============================================================================
// QUOTATIONS APIs
// ============================================================================
const QUOTATIONS = `${BASE_API_URL_FOR_NODEJS}/quotations`;
const QUOTATIONS_BY_ID = (id) => `${BASE_API_URL_FOR_NODEJS}/quotations/${id}`;

// ============================================================================
// RETURNS APIs
// ============================================================================
const RETURNS = `${BASE_API_URL_FOR_NODEJS}/returns`;
const RETURNS_BY_ID = (id) => `${BASE_API_URL_FOR_NODEJS}/returns/${id}`;

// ============================================================================
// MANUFACTURING CATEGORIES APIs
// ============================================================================
const MANUFACTURING_CATEGORIES = `${BASE_API_URL_FOR_NODEJS}/manufacturing-categories`;
const MANUFACTURING_CATEGORIES_BY_ID = (id) => `${BASE_API_URL_FOR_NODEJS}/manufacturing-categories/${id}`;

// ============================================================================
// PRODUCTS APIs (Public)
// ============================================================================
const PRODUCTS = `${BASE_API_URL_FOR_NODEJS}/products`;
const PRODUCTS_BY_ID = (id) => `${BASE_API_URL_FOR_NODEJS}/products/${id}`;
const CATEGORIES = `${BASE_API_URL_FOR_NODEJS}/categories`;
const PRODUCTS_CATEGORIES = `${BASE_API_URL_FOR_NODEJS}/products/categories`;
const PRODUCTS_CATEGORIES_LIST = `${BASE_API_URL_FOR_NODEJS}/products/categories/list`;
const PRODUCTS_GET_CATEGORIES = `${BASE_API_URL_FOR_NODEJS}/products/get-categories`;
const PRODUCTS_PRODUCT_CATEGORIES = `${BASE_API_URL_FOR_NODEJS}/products/product-categories`;

// ============================================================================
// ECOMMERCE APIs
// ============================================================================
const ECOMMERCE_PRODUCTS = `${BASE_API_URL_FOR_NODEJS}/ecommerce/products`;
const ECOMMERCE_PRODUCTS_BY_SLUG = (slug) => `${BASE_API_URL_FOR_NODEJS}/ecommerce/products/${slug}`;
const ECOMMERCE_CATEGORIES = `${BASE_API_URL_FOR_NODEJS}/ecommerce/categories`;
const ECOMMERCE_CART = `${BASE_API_URL_FOR_NODEJS}/ecommerce/cart`;
const ECOMMERCE_CART_ADD = `${BASE_API_URL_FOR_NODEJS}/ecommerce/cart/add`;
const ECOMMERCE_CART_UPDATE = `${BASE_API_URL_FOR_NODEJS}/ecommerce/cart/update`;
const ECOMMERCE_CART_REMOVE = (itemId) => `${BASE_API_URL_FOR_NODEJS}/ecommerce/cart/remove/${itemId}`;
const ECOMMERCE_WISHLIST = `${BASE_API_URL_FOR_NODEJS}/ecommerce/wishlist`;
const ECOMMERCE_WISHLIST_ADD = `${BASE_API_URL_FOR_NODEJS}/ecommerce/wishlist/add`;
const ECOMMERCE_WISHLIST_REMOVE = (productId) => `${BASE_API_URL_FOR_NODEJS}/ecommerce/wishlist/remove/${productId}`;
const ECOMMERCE_ORDERS = `${BASE_API_URL_FOR_NODEJS}/ecommerce/orders`;
const ECOMMERCE_ORDERS_BY_ID = (orderId) => `${BASE_API_URL_FOR_NODEJS}/ecommerce/orders/${orderId}`;
const ECOMMERCE_ORDERS_SYNC_BILLING = (orderId) => `${BASE_API_URL_FOR_NODEJS}/ecommerce/orders/${orderId}/sync-billing`;
const ECOMMERCE_BUY_NOW = `${BASE_API_URL_FOR_NODEJS}/ecommerce/buy-now`;
const ECOMMERCE_BILLINGS = `${BASE_API_URL_FOR_NODEJS}/ecommerce/billings`;

// Payments (Razorpay)
const ECOMMERCE_RZP_KEY = `${BASE_API_URL_FOR_NODEJS}/ecommerce/payments/razorpay/key`;
const ECOMMERCE_RZP_CREATE_ORDER = `${BASE_API_URL_FOR_NODEJS}/ecommerce/payments/razorpay/create_order`;
const ECOMMERCE_RZP_VERIFY = `${BASE_API_URL_FOR_NODEJS}/ecommerce/payments/razorpay/verify`;

// ============================================================================
// ECOMMERCE ADMIN APIs
// ============================================================================
const ECOMMERCE_ADMIN_PRODUCTS = `${BASE_API_URL_FOR_NODEJS}/ecommerce/admin/products`;
const ECOMMERCE_ADMIN_PRODUCTS_SYNC_STATUS = `${BASE_API_URL_FOR_NODEJS}/ecommerce/admin/products/sync-status`;
const ECOMMERCE_ADMIN_PRODUCTS_SYNC = `${BASE_API_URL_FOR_NODEJS}/ecommerce/admin/products/sync`;
const ECOMMERCE_ADMIN_ORDERS = `${BASE_API_URL_FOR_NODEJS}/ecommerce/admin/orders`;
const ECOMMERCE_ADMIN_REVIEWS = `${BASE_API_URL_FOR_NODEJS}/ecommerce/admin/reviews`;
const ECOMMERCE_ADMIN_COUPONS = `${BASE_API_URL_FOR_NODEJS}/ecommerce/admin/coupons`;

// ============================================================================
// EXPORT ALL APIs
// ============================================================================
export {
  // Authentication
  AUTH_LOGIN,
  AUTH_REGISTER,
  AUTH_ME,
  AUTH_PROFILE,
  AUTH_CHANGE_PASSWORD,
  AUTH_FORGOT_PASSWORD,
  AUTH_RESET_PASSWORD,
  ADMIN_LOGIN,

  // Admin
  ADMIN_USERS,
  ADMIN_USERS_UPDATE_ROLE,
  ADMIN_USERS_DELETE,
  UPDATE_ROLE_OF_ADMIN,
  UPDATE_NAME_OF_ADMIN,
  UPDATE_EMAIL_OF_ADMIN,
  DELETE_ADMIN_USER,
  UPDATE_ADMIN_USER_PASSWORD,
  UPDATE_ADMIN_USER,
  ADMIN_PRODUCTS,
  ADMIN_PRODUCTS_BY_ID,
  ADMIN_PRODUCTS_CATEGORIES,
  ADMIN_ORDERS,
  ADMIN_ANALYTICS,
  ADMIN_SALES_HISTORY,

  // Accounts
  ACCOUNTS,
  ACCOUNTS_PARENT,
  ACCOUNTS_CHART,
  ACCOUNTS_BY_ID,

  // Accounts Ledger
  ACCOUNTS_LEDGER,
  ACCOUNTS_LEDGER_BY_ID,

  // Billing
  BILLING,
  BILLING_BY_ID,
  BILLING_FROM_QUOTATION,
  BILLING_CLIENT_LEDGER,

  // Companies
  COMPANIES,
  COMPANIES_BY_ID,

  // Customers
  CUSTOMERS,
  CUSTOMERS_BY_ID,

  // Inventory
  INVENTORY,
  INVENTORY_BY_ID,

  // Quotations
  QUOTATIONS,
  QUOTATIONS_BY_ID,

  // Returns
  RETURNS,
  RETURNS_BY_ID,

  // Manufacturing Categories
  MANUFACTURING_CATEGORIES,
  MANUFACTURING_CATEGORIES_BY_ID,

  // Products (Public)
  PRODUCTS,
  PRODUCTS_BY_ID,
  CATEGORIES,
  PRODUCTS_CATEGORIES,
  PRODUCTS_CATEGORIES_LIST,
  PRODUCTS_GET_CATEGORIES,
  PRODUCTS_PRODUCT_CATEGORIES,

  // Ecommerce
  ECOMMERCE_PRODUCTS,
  ECOMMERCE_PRODUCTS_BY_SLUG,
  ECOMMERCE_CATEGORIES,
  ECOMMERCE_CART,
  ECOMMERCE_CART_ADD,
  ECOMMERCE_CART_UPDATE,
  ECOMMERCE_CART_REMOVE,
  ECOMMERCE_WISHLIST,
  ECOMMERCE_WISHLIST_ADD,
  ECOMMERCE_WISHLIST_REMOVE,
  ECOMMERCE_ORDERS,
  ECOMMERCE_ORDERS_BY_ID,
  ECOMMERCE_ORDERS_SYNC_BILLING,
  ECOMMERCE_BUY_NOW,
  ECOMMERCE_BILLINGS,
  
  // Payments (Razorpay)
  ECOMMERCE_RZP_KEY,
  ECOMMERCE_RZP_CREATE_ORDER,
  ECOMMERCE_RZP_VERIFY,
  

  // Ecommerce Admin
  ECOMMERCE_ADMIN_PRODUCTS,
  ECOMMERCE_ADMIN_PRODUCTS_SYNC_STATUS,
  ECOMMERCE_ADMIN_PRODUCTS_SYNC,
  ECOMMERCE_ADMIN_ORDERS,
  ECOMMERCE_ADMIN_REVIEWS,
  ECOMMERCE_ADMIN_COUPONS,
};

